module.exports = __webpack_public_path__ + "img/personnage-heureux.78a26523.png";